const isTesting = false;
const isProd = process.env.NODE_ENV === `production` && !isTesting;
const AlgoliaAppId = isProd ? process.env.GATSBY_ALGOLIA_APP_ID_PROD : process.env.GATSBY_ALGOLIA_APP_ID_DEV;
const AlgoliaSearchKey = isProd? process.env.GATSBY_ALGOLIA_SEARCH_KEY_PROD : process.env.GATSBY_ALGOLIA_SEARCH_KEY_DEV;
const AlgoliaAdminKey = isProd? process.env.ALGOLIA_ADMIN_KEY_PROD : process.env.ALGOLIA_ADMIN_KEY_DEV;

const AlgoliaKey = {
    appId : AlgoliaAppId,
    searchKey : AlgoliaSearchKey,
    adminKey : AlgoliaAdminKey,
}

module.exports = AlgoliaKey;